import { useState, useCallback, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { QuoteDialog } from "@/components/QuoteDialog";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import CorporateAV from "@/pages/CorporateAV";
import CorporateEvents from "@/pages/CorporateEvents";
import AVGearList from "@/pages/AVGearList";
import BeachGear from "@/pages/BeachGear";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => window.scrollTo(0, 0), [pathname]);
  return null;
}

function App() {
  const [quoteOpen, setQuoteOpen] = useState(false);
  const [presetItem, setPresetItem] = useState("");

  // App mounted successfully. Remove the loading spinner immediately, and reset
  // the deploy auto-reload counter ONLY after a stable, error-free window — so a
  // persistently-failing same-origin asset can never loop (throttle caps at 2).
  useEffect(() => {
    if (window.__clearAppLoading) window.__clearAppLoading();
    const timer = setTimeout(() => {
      if (!window.__av30aResourceError) {
        try {
          localStorage.removeItem("av30a_reload_attempts");
        } catch (e) { /* ignore */ }
      }
    }, 8000);
    return () => clearTimeout(timer);
  }, []);

  const openQuote = useCallback((item = "") => {
    setPresetItem(typeof item === "string" ? item : "");
    setQuoteOpen(true);
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar onQuote={() => openQuote()} />
        <main>
          <Routes>
            <Route path="/" element={<Home onQuote={openQuote} />} />
            <Route path="/corporate-av" element={<CorporateAV onQuote={openQuote} />} />
            <Route path="/corporate-events" element={<CorporateEvents onQuote={openQuote} />} />
            <Route path="/av-gear-list" element={<AVGearList onQuote={openQuote} />} />
            <Route path="/beach-gear" element={<BeachGear onQuote={openQuote} />} />
          </Routes>
        </main>
        <Footer onQuote={() => openQuote()} />
        <QuoteDialog
          open={quoteOpen}
          onOpenChange={setQuoteOpen}
          presetItem={presetItem}
          category="general"
        />
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
